import { Model } from "#/shared/models/model";

export class AppointmentSlot extends Model {
  get defaults() {
    return {
      id: undefined,

      patientType: undefined,

      visitTypeId: undefined,

      providerVisitTypeIds: undefined,
      providerSpecialtyIds: undefined,
      providerLocationId: undefined,
      providerDepartmentId: undefined,
      providerNetworkIds: undefined,
      providerTypeIds: undefined,
      providerGroupIds: undefined,
      providerPortalLinks: undefined,

      providerLicensedStates: undefined,
      providerLicensedStateNames: undefined,

      providerMinimumAge: undefined,
      providerMaximumAge: undefined,

      providerName: undefined,
      providerPhoneNumber: undefined,

      providerType: undefined,
      providerTypeDescription: undefined,

      licensedProviderSearchUrl: undefined,
    };
  }
}
